module.exports = __webpack_public_path__ + "static/media/broken-token.6bbb1e23.svg";